import { executeRequest, JFSRequest } from '@jfs/network'
import { getIdFromMap, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getRequestBody = (data: any) => {
  const request = {
    id: data?.id,
    ruleName: data?.ruleName,
    payeeType: data?.payeeType,
    payeeUserId: data?.payeeUserId,
    payeeVpa: data?.payeeVpa,
    payerBankId: data?.payerBankId,
    binList: data?.binList,
    binRange: data?.binRange,
    cardType: getIdFromMap(data?.cardType),
    scheme: getIdFromMap(data?.scheme),
    amount: data?.amount,
    transactionInitiatingEntityId: getIdFromMap(data?.transactionInitiatingEntityId),
    transactionApplication: data?.transactionApplication,
    txntype: getIdFromMap(data?.txntype),
    instrumentType: getIdFromMap(data?.instrumentType),
    mode: data?.mode,
    activationGroup: data?.activationGroup,
    priority: data?.priority,
    processor: data?.processor,
    isActive: data?.isActive === 'Enable' || data?.isActive === 'Enabled' ? 'Y' : 'N',
    isAssigned: data?.isAssigned,
  }
  console.log({ request })
  return request
}

const deleteRoutingRule = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.deleteStaticRouting),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { deleteRoutingRule }
